import { convertToEditableCriteria } from './convertToEditableCriteria';
import { createBlankQuery } from './createBlankQuery';
import { CompleteQuery, EditableQuery } from '../types';

/** converts CompleteQuery to EditableQuery */
export const convertToEditableQuery = (query: CompleteQuery): EditableQuery =>
  createBlankQuery({
    ...query,
    searchQueries: query.searchQueries.map(convertToEditableCriteria),
  });
